


























import {
  defineComponent,
  useRoute,
  ref,
  useFetch,
  useContext
} from '@nuxtjs/composition-api'
import { useBlog } from '@wemade-vsf/blog'
import { useCache } from '@wemade-vsf/cache';
import { useImage } from '@wemade-vsf/composables';
import { BlogPost } from '@wemade-vsf/magento-api'
import { SfHeading, SfImage, SfSkeleton, SfBreadcrumbs } from '@storefront-ui/vue'
import CmsContent from 'components/theme/Content/CmsContent.vue'
import { getMetaInfo } from '@wemade-vsf/core';

export default defineComponent({
  name: 'BlogPost',
  components: {
    SfHeading,
    SfImage,
    SfSkeleton,
    SfBreadcrumbs,
    CmsContent
  },
  setup () {
    const { error: nuxtError, i18n, localeRoute, app: { $img } } = useContext()
    const route = useRoute()
    const { getPostDetails, loading } = useBlog()
    const breadcrumbs = ref<Array<{text: string, link: string}>|null>(null)
    const post = ref<BlogPost | null>(null)
    const { addTags } = useCache();

    const { getMagentoImage } = useImage();
    const postImage = ref<string | null>(null);
   
    useFetch(async () => {
      post.value = await getPostDetails(route.value.params.slug)

      if (Boolean(post?.value?.url_key) === false) nuxtError({ statusCode: 404})
      postImage.value = post.value?.image
        ? $img(getMagentoImage(post.value.image), { width: 600, height: 600, fit: 'contain', format: 'jpg' })
        : null;

      breadcrumbs.value = [
        { text: i18n.t('Home'), link: localeRoute({ name: 'home'}).fullPath },
        { text: i18n.t('Blog'), link: localeRoute({ name: 'blog'}).fullPath },
        { text: post.value.name || '', link: localeRoute({ name: 'blogPost', params: { slug: post.value.url_key || '' } }).fullPath }
      ]

      addTags([{
        prefix: 'BL',
        value: route.value.params.slug
      }])
    })

    return {
      breadcrumbs,
      loading,
      post,
      postImage
    }
  },
  head () {
    const seoTags = getMetaInfo(this.post);
    let meta = seoTags?.meta ?? [];

    if (this.postImage) {
      meta.push({
        hid: 'og:image',
        name: 'og:image',
        property: 'og:image',
        //@ts-ignore
        content: String(this.$i18n.__baseUrl + this.postImage)
      });
    }
    return {
      ...seoTags,
      meta
    }
  }
})
